export const COLUMNS = [
  {
    Header: "Passport No",
    Footer: "Ref No",
    accessor: row => row.passportNo || 'N/A',
  },
  {
    Header: "Full Name",
    Footer: "firstName",
    accessor: row => row.Employee ? `${row.Employee.firstName} ${row.Employee.lastName}` : 'N/A',
  },
  {
    Header: "Mobile",
    Footer: "",
    accessor: row => row.Employee?.mobile || 'N/A'
  },
  {
    Header: "Agent",
    Footer: "",
    accessor: row => row.Employee?.Agent?.name || 'N/A',
  },
  {
    Header: "Expiry Date",
    Footer: "mobile",
    accessor: row => row.expiryDate || 'N/A',
  },
  {
    Header: "Days until expiry",
    Footer: "passport",
    accessor: row => row.daysUntilExpiry || 'N/A',
  },
];

